export default __webpack_public_path__ + "static/media/background.985a4c1c.jpg";